<button mat-button
        [type]="type ? type : null"
        [ngClass]="{
          light,
          bold,
          small,
          auxiliary,
          'auxiliary-light-blue' : auxiliaryLightBlue,
          'auxiliary-clean': auxiliaryClean,
          'auxiliary-gray': auxiliaryGray,
          'transparent': transparent
        }"
        color="primary"
        [disabled]="isDisabled()"
        (click)="emitClick()"
        >
  <mat-icon *ngIf=icon>{{icon}}</mat-icon>
  <span>
    <ng-content></ng-content>
  </span>
</button>
